var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fup-content-block",
    { attrs: { container: true, "full-size": false } },
    [
      _c("div", { staticClass: "mt-4 mb-4 text-center" }, [
        _c("p", { staticClass: "lead text-muted" }, [
          _c("i", { staticClass: "far fa-hourglass-half" })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "small text-muted" }, [
          _vm._v("Произошла ошибка, повторите позже.")
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }